<div class="card about-card">
    <div class="section-header">
        <h2 class="section-title">{{ 'profileAbout.about' | translate }}</h2>
        <button class="icon-btn" [title]="'profileAbout.edit' | translate" (click)="openEditModal()"
            *ngIf="mode=='edit'">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
            </svg>
        </button>
    </div>

    <p *ngIf="about" class="about-text">{{ preview }}</p>
    <p *ngIf="!about && mode=='edit'" class="about-text dummy">
        {{ 'profileAbout.writeShortSummaryPlaceholder' | translate }}
    </p>
    <p *ngIf="!about && mode=='view'" class="about-text dummy">
        {{ 'profileAbout.writeShortSummarycompanyPlaceholder' | translate }}
    </p>

    <button *ngIf="about && about.length > 160" class="toggle-btn" (click)="expanded = !expanded">
        {{ expanded ? ('profileAbout.showLess' | translate) : ('profileAbout.showMore' | translate) }}
    </button>
</div>

<!-- Edit About Modal — outside .card -->
<div class="modal-overlay" *ngIf="isEditModalOpen && mode=='edit'" (click)="closeEditModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">

        <button class="close-btn" (click)="closeEditModal()">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
        </button>

        <div class="modal-header">
            <h3 class="modal-title">{{ 'profileAbout.editAbout' | translate }}</h3>
        </div>

        <div class="modal-body">
            <form [formGroup]="aboutForm">
                <div class="form-group">
                    <label for="about">{{ 'profileAbout.about' | translate }}</label>
                    <textarea id="about" formControlName="about" class="form-textarea"
                        [placeholder]="'profileAbout.writeShortSummaryPlaceholder' | translate" rows="6"></textarea>
                    <span class="char-count">{{ aboutForm.value.about?.length || 0 }} {{ 'profileAbout.characters' |
                        translate }}</span>
                </div>
            </form>

            <div class="modal-actions">
                <button class="btn btn-cancel" (click)="closeEditModal()">{{ 'profileAbout.cancel' | translate
                    }}</button>
                <button class="btn btn-save" (click)="saveAbout()" [disabled]="isSaving">
                    <span *ngIf="!isSaving">{{ 'profileAbout.saveChanges' | translate }}</span>
                    <span *ngIf="isSaving">{{ 'profileAbout.saving' | translate }}</span>
                </button>
            </div>
        </div>

    </div>
</div>